import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import {
  ApiConfig,
  provideIwentsourcingAuth,
} from '../../../common/src/lib/provide-api.js';
import { createRpcClient } from '@iwentsourcing/client/api/create-rpc-client.js';
import { createBrowserEnv } from '@iwentsourcing/browser/create-browser-env';
import { routes } from './app.routes.js';
import { todoRealm } from '../state/realm.js';
import { environment } from '../environments/environment.js';

const todoApiConfig: ApiConfig = {
  host: environment.host,
  async getProviders(tenant: string, realm: string) {
    const rpc = createRpcClient({
      url: environment.host,
      env: createBrowserEnv(),
    });
    const { providers } = await rpc['auth.publicProviders'].call(
      { tenant, realm },
      new AbortController().signal,
    );
    return providers;
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      }),
    ),
    { provide: ApiConfig, useValue: todoApiConfig },
    provideIwentsourcingAuth({
      unauthorizedUrl: '/',
      authorizedUrl: '/personal',
      logoUrl: '/icon200h.png',
      realm: todoRealm.name,
      tenant: 'todo',
    }),
  ],
};
